import { createFileRoute } from "@tanstack/react-router";
import { Id } from "@/convex/_generated/dataModel";
import ContainerEditClient from "@/components/logistics/containers/container-edit-client";

export const Route = createFileRoute(
  "/_authenticated/logistics/containers/$id/edit",
)({
  component: ContainerEditPage,
});

function ContainerEditPage() {
  const { id } = Route.useParams();

  return <ContainerEditClient id={id as Id<"shipments">} />;
}
